// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__26Y3Q","form":"styles_form__3lAE0"};